import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Invoicing
export const createInvoice = (invoice: any) => api.create(url.CREATE_INVOICE, invoice);
export const getInvoicesList = (params: any) => api.get(url.GET_INVOICES_LIST, { params });
export const getInvoiceFile = (accessKey: string, extension: string) =>
    api.get(`${url.GET_INVOICE_FILE}/${accessKey}/${extension}`);
export const retryInvoiceApi = (data: { progressJobId: string; progressStatus: string }) => api.create(url.RETRY_INVOICE, data);
